import ClientAgentExtender from '../../../Common/clientAgentExtender'
import Preusmeritev from './Preusmeritev'
import {PhoneNumberValidator} from '../../../globalne_funkcije/GlobalnoTelefonija/PhoneNumberValidator'

export default class Preusmeritve extends ClientAgentExtender {
  _idPrikljucek = null
  _stevilka = null
  _idSimKartica = null
  _zaporeKlicev = null
  _preusmeritve = null
  _loadingItems = false
  _loadingSave = false

  constructor (idPrikljucek, stevilka, idSimKartica) {
    super()
    this._idPrikljucek = idPrikljucek
    this._stevilka = stevilka
    this._idSimKartica = idSimKartica
  }

  async loadData (override = false) {
    this._loadingItems = true
    if (this._zaporeKlicev === null || override) {
      let response = await this.ca.makeRequest(
        'prikljucek/telefonija/umts/pridobiZaporeKlicev',
        {idPrikljucek: this._idPrikljucek, stevilka: this._stevilka},
        'GET'
      )
      this._zaporeKlicev = response.data
    }
    if (this._preusmeritve === null || override) {
      let response = await this.ca.makeRequest(
        'prikljucek/telefonija/umts/sim/redirects',
        {idSimKartica: this._idSimKartica},
        'GET'
      )
      let tmpRedirects = []
      response.redirects.forEach(redirect => {
        tmpRedirects.push(Preusmeritev.createFromResponseItem(redirect))
      })
      this._preusmeritve = tmpRedirects
    }
    this.reloadDisabledAttributes()
    this._loadingItems = false
  }

  reloadDisabledAttributes () {
    this._preusmeritve.forEach((pre) => {
      pre.disabled = false
      pre.disabledMessage = ''
    })
    this._zaporeKlicev.forEach((item) => {
      if (item.active && item.excludedIds != null) {
        this._preusmeritve.forEach((pre) => {
          if (item.excludedIds.indexOf(pre.id) !== -1) {
            pre.disabled = true
            pre.disabledMessage = 'Onemogočeno zaradi aktivne zapore klicev "' + item.name + '"'
          }
        })
      }
    })
    this._preusmeritve.forEach((pre) => {
      if (pre.active && pre.excludedIds != null) {
        this._preusmeritve.forEach((pre2) => {
          if (pre.excludedIds.indexOf(pre2.id) !== -1) {
            pre2.disabled = true
          }
        })
      }
      pre.redrawRedirectOptions()
    })
  }

  async save () {
    try {
      this._loadingSave = true
      this.checkFormValid()
      let preusmeritveTmp = []
      this.preusmeritve.forEach((pre) => {
        let tmpOptions = []
        if (pre.redirectOptions != null) {
          pre.redirectOptions.forEach(redirect => {
            tmpOptions.push({
              active: redirect.active,
              type: redirect.type
            })
          })
        }
        let reqObj = {
          id: pre.id,
          active: pre.active,
          number: pre.number,
          time: pre.time
        }
        if (tmpOptions.length > 0) {
          reqObj.redirectOptions = tmpOptions
        }
        preusmeritveTmp.push(reqObj)
      })
      let params = {
        idSimKartica: this._idSimKartica,
        redirects: JSON.stringify(preusmeritveTmp)
      }
      await this.ca.makeRequest(
        'prikljucek/telefonija/umts/sim/redirects',
        params,
        'PATCH'
      )
      await this.loadData(true)
      this._loadingSave = false
    } catch (e) {
      this._loadingSave = false
      throw e
    }
  }

  checkFormValid () {
    let formValid = true

    this.preusmeritve.forEach(p => {
      if (p.active === true && p.selectedRedirectOption === 'number') {
        if (p.number != null && p.number !== '') {
          p.number = p.number.replace(/^\+/, '')
        }
        if (
          !PhoneNumberValidator.methods.ValidateSLOMobileNumber(p.number) &&
          !PhoneNumberValidator.methods.ValidateSLOFixNumber(p.number)
        ) {
          formValid = false
        }
      }
    })

    if (!formValid) {
      throw new Error('Vpisane številke preusmeritev niso veljavne.')
    }
  }

  get zaporeKlicev () {
    return this._zaporeKlicev
  }

  set zaporeKlicev (value) {
    this._zaporeKlicev = value
  }

  get preusmeritve () {
    return this._preusmeritve
  }

  set preusmeritve (value) {
    this._preusmeritve = value
  }

  get loadingItems () {
    return this._loadingItems
  }

  set loadingItems (value) {
    this._loadingItems = value
  }

  get loadingSave () {
    return this._loadingSave
  }

  set loadingSave (value) {
    this._loadingSave = value
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/Prikljucek/Telefonija/Umts/Preusmeritve.js